<template>
  <div class="service-content-modal">
    <div class="modal-content-header">
        <h1>Terms of Service</h1>
    </div>
    <div class="modal-content-mainer">
        <n-scrollbar style="height: calc(696px - 96px - 114px)">
            <TermsServiceTextContent />
        </n-scrollbar>
    </div>
    <div class="modal-content-footer">
        <div class="btn-group-control">
            <!-- <n-button class="br30" :color="'#ffffff'" text-color="#000000" @click="emits('onClose')">Disagree</n-button> -->
            <n-button class="br30" :color="'#000000'" text-color="#ffffff" @click="emits('onConfirm')">I Know</n-button>
        </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { NScrollbar, NButton } from "naive-ui";
import TermsServiceTextContent from "./TermsServiceTextContent.vue";
const emits = defineEmits([
    "onClose",
    "onConfirm",
]);
</script>
<style lang="scss" scoped>
@import url(../scss/service_content.scss);
</style>
